module.exports = __webpack_public_path__ + "222da0586f2f0c526fca78a9c9189521.png";